import React from 'react';
import { translate, Trans } from 'react-i18next';
import {Link} from 'react-router-dom';
import {Button, Form, Input, Grid, Modal, Message, Label, Segment} from 'semantic-ui-react';

import ConfirmGroupSwitch from './ConfirmGroupSwitch.js';
import {withError} from 'modules/misc/ErrorPage.js';
import Utils from 'utils/Utils.js';
import {colors, shadow, spacings, fonts, layout, buttons} from 'style';
import styleDef from './style.js';


var style = {
    ...styleDef,
    content: {
        ...fonts.body,
        lineHeight: '1.5',
        minHeight: '100%',
        maxWidth: layout.screenWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
        color: colors.themeDarkerGrey,
        backgroundColor: 'white',
        boxShadow: layout.screenShadow,
    },
    header: {
        ...fonts.h2,
        lineHeight: '1.5',
        textAlign: 'center',
        color: colors.themeBlue,
        margin: spacings.large,
    },
    subheader: {
        ...fonts.h4,
        lineHeight: '1.5',
        color: colors.themeBlue,
        margin: spacings.base,
    },
    description: {
        ...fonts.bodyL,
        textAlign: 'center',
        margin: spacings.large,
    },
    optionRow: {
        cursor: 'pointer',
        margin: spacings.base,
        borderBottom: '1 px solid grey',
        height: '61px',
        lineHeight: '61px',
    },
    optionRowContent: {
        padding: spacings.tiny,
        lineHeight: '1.5',
    },
    optionImage: {
        float: 'left',
        textAlign: 'center',
        width: '61px',
        height: '61px',
        lineHeight: '61px',
        border: '0px solid ' + colors.themeDarkGrey,
        borderRadius: '8px',
        boxShadow: shadow,
        marginRight: spacings.small,
        marginLeft: spacings.small,
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
    },
    groupIcon: {
        color: colors.themeTeal,
        fontSize: '30px',
        margin: '0',
        width: '30px',
        height: '30px',
        display: 'inline',
    },
    noGroupIcon: {
        color: colors.themeBlue,
        position: 'relative',
        top: '2px',
    },
    rightArrow: {
        float: 'right',
        fontWeight: 'bold',
        color: colors.themeDarkGrey,
    },
    optionName: {
        ...fonts.body,
    },
    optionDescription: {
        ...fonts.bodyS,
        opacity: '0.75',
    },
    button: {
        ...buttons.base,
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    buttonDisabled: {
        ...buttons.base,
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: colors.themeDarkGrey,
    },
    fields: {
        marginTop: spacings.large,
        marginBottom: spacings.large,
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '300px',
    }
};


const EnterGroupCode = ({t, 
                         valid,
                         groupCode,
                         switchCompanyError,
                         showConfirm,
                         onConfirm,
                         onCancel,
                         onChange,
                         onSubmit,
                         onHideError}) => (
    <Form style={style.content} onSubmit={onSubmit}>
        <br />
        <div style={style.header}>{t('enter_group_code')}</div>
        <div style={style.description}>{Utils.endlToBr(t('join_group_message'))}</div>


        <div style={style.fields}>
            <div style={style.inputLabel}>{t('group_code')}</div>
            <Form.Field style={style.field}>        
                <input 
                    style={{...style.input}}
                    type="text"
                    name="groupCode"
                    value={groupCode}
                    onChange={onChange}
                    required
                />
            </Form.Field>        
        </div>

        <Button type='submit' style={valid ? style.button : style.buttonDisabled}>{t('join_group')}</Button>
        
        {switchCompanyError &&
            <Modal closeIcon open onClose={onHideError}>
                <Modal.Content>
                    <Message negative>{String(switchCompanyError)}</Message>
                </Modal.Content>
            </Modal>
        }

        {showConfirm &&
            <ConfirmGroupSwitch onClose={onCancel} onConfirm={onConfirm}/>
        }
    </Form>
);

export default withError(translate('authentication')(EnterGroupCode));



// WEBPACK FOOTER //
// ./src/modules/authentication/EnterGroupCode.js